import { createZodDto } from "nestjs-zod/dto";
import { z } from "zod";

export const toolTypeSchema = z.enum([
  "ATS_CHECKER",
  "RESUME_ROASTER",
  "LINKEDIN_ENDORSEMENT",
  "LINKEDIN_PROFILE_REVIEW",
]);
export const ctaClickSourceSchema = z.enum(["results", "rate-limit", "upgrade_cta", "post_review_cta"]);

export const ctaClickSchema = z.object({
  tool: toolTypeSchema,
  source: ctaClickSourceSchema,
});

export class CtaClickDto extends createZodDto(ctaClickSchema) {}

export type ToolTypeValue = z.infer<typeof toolTypeSchema>;
export type CtaClickSource = z.infer<typeof ctaClickSourceSchema>;
